import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerAchRemoveEffects {
	remove = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.ach.remove),
			switchMap((action) => {
				return this.consumerAdminService.removeBankAccount(action.accountId).pipe(
					map(() => ConsumerAdminActions.ach.removeSuccess()),
					catchError((error) =>
						of(ConsumerAdminActions.ach.removeFail(new FailState(error)))
					)
				);
			})
		)
	);

	constructor(
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}
}
